module.exports = __webpack_public_path__ + "static/media/trainers.7ec1aff2.svg";